import React from 'react';
import { Form, Input, Select, Button, Row, Col, Space } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { PANEL_PRIMARY_BTN_CLASS } from '../../constants/ui';
import ClientSelect from '../common/ClientSelect';

const { TextArea } = Input;

const NoticeForm = ({
  form,
  submitting = false,
  teams = [],
  employees = [],
  clients = [],
  onSubmit,
  onCancel,
}) => {
  const toValue = Form.useWatch('to', form);

  const handleFinish = (values) => {
    const target = values.to || 'employee';
    const basePayload = {
      to: target,
      heading: values.heading?.trim() || '',
      description: values.description?.trim() || '',
      team_id: target === 'client' ? 0 : Number(values.team_id || 0),
    };

    if (target === 'client') {
      onSubmit({
        ...basePayload,
        clients: (values.clients || []).map((id) => Number(id)),
      });
      return;
    }

    onSubmit({
      ...basePayload,
      employees: (values.employees || []).map((id) => Number(id)),
    });
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish} className="custom-font">
      <Row gutter={[16, 0]}>
        <Col xs={24} md={12}>
          <Form.Item name="to" label="ارسال برای" rules={[{ required: true, message: 'نوع را انتخاب کنید' }]}>
            <Select popupClassName="custom-font">
              <Select.Option value="employee">کارمندان</Select.Option>
              <Select.Option value="client">مشتریان</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="team_id"
            label="تیم"
            rules={
              toValue === 'employee'
                ? [{ required: true, message: 'تیم را انتخاب کنید' }]
                : []
            }
          >
            <Select
              disabled={toValue === 'client'}
              placeholder={toValue === 'client' ? 'برای مشتری غیرفعال است' : 'انتخاب تیم'}
              popupClassName="custom-font"
            >
              {(teams || []).map((t) => (
                <Select.Option key={t.id} value={t.id}>
                  {t.team_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item name="heading" label="عنوان" rules={[{ required: true, message: 'عنوان را وارد کنید' }]}>
        <Input />
      </Form.Item>

      {toValue === 'client' ? (
        <Form.Item
          name="clients"
          label="مشتریان"
          rules={[{ required: true, message: 'حداقل یک مشتری انتخاب کنید' }]}
        >
          <ClientSelect
            mode="multiple"
            placeholder="انتخاب مشتری"
            popupClassName="custom-font"
            knownOptions={(clients || []).map((c) => ({ value: c.id, label: c.name, mobile: c.mobile }))}
          />
        </Form.Item>
      ) : (
        <Form.Item
          name="employees"
          label="کارمندان"
          rules={[{ required: true, message: 'حداقل یک کارمند انتخاب کنید' }]}
        >
          <Select mode="multiple" showSearch optionFilterProp="children" placeholder="انتخاب کارمند" popupClassName="custom-font">
            {(employees || []).map((e) => (
              <Select.Option key={e.id} value={e.id}>
                {e.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      )}

      <Form.Item
        name="description"
        label="توضیحات"
        rules={[{ required: true, message: 'توضیحات را وارد کنید' }]}
      >
        <TextArea rows={5} />
      </Form.Item>

      <Space wrap>
        <Button
          type="primary"
          htmlType="submit"
          icon={<SaveOutlined />}
          loading={submitting}
          className={PANEL_PRIMARY_BTN_CLASS}
        >
          ذخیره
        </Button>
        <Button onClick={onCancel}>انصراف</Button>
      </Space>
    </Form>
  );
};

export default NoticeForm;
